import React, { useState } from 'react'
import { Col, Icon, IconButton, Panel, Row } from 'rsuite'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import pathname from '../../../constants/pathname'
import { doneLoading, startLoading } from '../../../utils/loading'
import notification from '../../../utils/notification'
import { DEFAULT_ERR_MSG } from '../../../constants/msgText'
import { downloadFile } from '../../../utils/fileUtil'
import {
  downloadDashboardProjectBudgetReport,
  downloadSubProjectCounterSummaryDetail,
} from '../../../redux/actions/dashboard'
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader'
import SubProjectListSatusReportTable from './SubProjectListSatusReportTable'

export default function SubProjectListSatusReportWidget(props) {
  const history = useHistory()

  const [isLoading, setIsLoading] = useState(false)
  const [dataTable, setDataTable] = useState(props.schema)

  const handleExportFile = async () => {
    setIsLoading(true)
    startLoading()
    try {
      //let req = sessionStorage.getItem('up-down-strem-req')
      let key = sessionStorage.getItem('up-down-strem-key')
      let masterKey = sessionStorage.getItem('up-down-strem-master-key')
      let status = sessionStorage.getItem('up-down-strem-status')

      let req = {
        masterKey: masterKey,
        key: key,
      }
      const file = await downloadSubProjectCounterSummaryDetail(req)
      //console.log('file => ', file)

      if (file) {
        downloadFile(file, file.name || `รายการโครงการ ${status || ''}`)
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      console.log('handleExportFile error : ', e)
      notification.open('error', {
        title: e?.errors?.message || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSelect = (request) => {
    sessionStorage.setItem('projectId', request.projectVersionId)
    sessionStorage.setItem('param', '')

    history.push(`${pathname.subProject.overviewSubProject}`)
  }

  return (
    <>
      {isLoading && <OverlayLoader />}

      <Panel shaded collapsible defaultExpanded header={''} bordered>
        <Row style={{ marginTop: 20 }}>
          <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <IconButton
              appearance="ghost"
              icon={<Icon icon="print" className="bt-gost-icon-radius" />}
              onClick={() => {
                handleExportFile()
              }}
            >
              Export
            </IconButton>
          </Col>
        </Row>

        <SubProjectListSatusReportTable
          schema={dataTable}
          loading={isLoading}
          onSelect={onSelect}
        />
      </Panel>
    </>
  )
}
